import {MarginSliderCard} from './calculator/MarginSliderCard'
import {ContractsSliderCard} from './calculator/ContractsSliderCard'
import {NastupySliderCard} from './calculator/NastupySliderCard.tsx'
import {NastupyBonusCard} from './calculator/NastupyBonusCard.tsx'
import {MarginBonusCard} from './calculator/MarginBonusCard'
import {ContractsBonusCard} from "@/components/calculator/ContractsBonusCard.tsx";
import {PercentageTable} from "@/components/PercentageTable.tsx";
import {NastupyTable} from "@/components/NastupyTable.tsx";
import {ContractsTable} from "@/components/ContractsTable.tsx";
import {NastupyVisualCard} from './calculator/NastupyVisualCard.tsx'
import {TotalPeriodCard} from "@/components/calculator/TotalPeriodCard.tsx";
import { PeriodTabs } from './calculator/PeriodTabs'
import { CalculatorHeader } from './calculator/CalculatorHeader'
import {MarginBonusPreviousCard} from "@/components/calculator/MarginBonusPreviousCard.tsx";

export function CalculatorContent() {
    return (
        <div className="flex flex-col gap-6">
            <CalculatorHeader />
            <PeriodTabs>
                <div className="space-y-6">
                    {/* <div className="grid gap-6">
                        <TotalCommissionCard/>
                    </div> */}

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <MarginSliderCard/>
                        <NastupySliderCard/>
                        <ContractsSliderCard/>
                        <NastupyVisualCard/>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <MarginBonusCard/>
                        <NastupyBonusCard/>
                        <ContractsBonusCard/>
                        <TotalPeriodCard/>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <PercentageTable/>
                        <NastupyTable/>
                        <ContractsTable/>
                        <MarginBonusPreviousCard/>
                    </div>
                </div>
            </PeriodTabs>
        </div>
    )
} 